import React from 'react';

import { ResponsiveContainer, BarChart as RechartsBarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';

const BarChart = ({ width, data }) => (
    <ResponsiveContainer width={width} minHeight={180} maxHeight={300} aspect={1}>
        <RechartsBarChart height={250} data={data}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="with Group" fill="#8884d8" />
            <Bar dataKey="without Group" fill="#82ca9d" />
        </RechartsBarChart>
    </ResponsiveContainer>
);

export default BarChart;
